import { useQuery } from '@tanstack/react-query';
import { getAccountCabinetOnboardingState } from '../../api/getAccountCabinetOnboardingState/getAccountCabinetOnboardingState';

export const useGetOnboardingState = () => {
  const { data: onboardingState, isSuccess: isOnboardingStateSuccess } =
    useQuery({
      queryKey: ['onboarding-state'],
      queryFn: getAccountCabinetOnboardingState,
    });

  return { onboardingState, isOnboardingStateSuccess };
};
